/*
 * Public API Surface of pepperi-lib/textbox
 */
export * from './textbox.module';
export * from './textbox.component';
